import { useEffect, useRef } from "react";

/**
 * Fades the referenced section out as the user scrolls past it,
 * creating a seamless transition into the next section.
 */
export function useHeroFade<T extends HTMLElement = HTMLElement>() {
  const ref = useRef<T>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    let raf = 0;
    const update = () => {
      raf = 0;
      const h = el.offsetHeight || window.innerHeight;
      const y = window.scrollY;
      const start = h * 0.5;
      const end = h * 0.95;
      const t = Math.min(1, Math.max(0, (y - start) / (end - start)));
      el.style.opacity = String(1 - t);
    };
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(update);
    };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return ref;
}
